import {
  UseMutationResult,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { deleteCarouselShow, CAROUSEL_QUERY_KEY } from "./api";

interface DeleteCarouselShowParams {
  venuePageId: string;
  showId: string;
}

/**
 * Hook to delete a show from the carousel
 */
export function useDeleteCarouselShow(): UseMutationResult<
  { success: boolean },
  Error,
  DeleteCarouselShowParams
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ venuePageId, showId }: DeleteCarouselShowParams) =>
      deleteCarouselShow(venuePageId, showId),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: [CAROUSEL_QUERY_KEY, variables.venuePageId],
      });
    },
  });
}
